import { usePostHog } from 'posthog-js/react';
import packageJson from '../../package.json';
import { REFINE_ANALYTICS_EVENTS } from 'src/types/RefineAnalyticsEvents';

export const useAnalytics = () => {
	const posthog = usePostHog();
	const queryParams = new URLSearchParams(window.location.search);
	const shortCode = queryParams.get('sc') ?? '';
	const version = packageJson.version || 'unknown';

	const trackRefineEvent = (eventName: REFINE_ANALYTICS_EVENTS, properties?: any) => {
		posthog.capture(eventName, {
			...(properties && { ...properties }),
			appVersion: version,
			shortCode,
		});
	};

	return { trackRefineEvent };
};
